<template>
    <b-card>
        <div style="overflow: hidden;">
            <div class="product-holder">
                <b-img :src="imgSrc" 
                    rounded width="100" height="100"
                />
                <b-img src="https://i.imgur.com/UvWrx6Q.png" 
                    class="plus-image"
                    width="50" height="50"
                />
            </div>
            <div class="details">
                <div class="text-success font-weight-bold"> 
                    {{name}}
                </div>
                <div> 
                    {{description}}
                </div>
                <div style="position: absolute; bottom: 20px;" class="text-muted">
                    {{numberOfPlaces}} Places · By <b-link class="text-success">{{creator}}</b-link>
                </div>
            </div>
        </div>
    </b-card>
</template>

<style scoped>
.product-holder {
    position: relative;
    display: block;
    float: left;
}

.plus-image {
    left: 50%;
    top: 50%;
    position: absolute;
    margin-bottom: -25px;
    margin-right: -25px;
}

.details {
    margin-left: 110px;
}

</style>

<script>
export default {
    props: {
        imgSrc: {
            type: String
        },
        name: {
            type: String
        },
        description: {
            type: String,
            default: ""
        },
        numberOfPlaces: {
            type: Number
        },
        creator: {
            type: String
        }
    },
    data() {
        return {
            
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>